import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton,
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download, Link as LinkIcon } from "@mui/icons-material";
import { DialogContentText } from "@mui/material";

import { useState, useEffect } from "react";
import {
  Box,
} from "@mui/material";

import Config from "../config.json";
import { dateToStringDate } from "../Helpers";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));


const timelineData = [
  { no: 1, activity: "Publish Specific Procurment Notice (SPN) - Request for Bids (RFB)", start: "26-Aug-25", end: "21-Oct-25" },
  { no: 2, activity: "Clarification Period - Bidders can ask questions", start: "29-Aug-25", end: "26-Sep-25" },
  { no: 3, activity: "Deadline for Submission of Bids", start: "26-Aug-25", end: "21-Oct-25" },
  { no: 4, activity: "Public Bid Opening of Technical Parts of Bids", start: "21-Oct-25", end: "21-Oct-25" },
  { no: 5, activity: "Clarification of Technical Parts of Bids", start: "21-Oct-25", end: "25-Mar-25" },
  { no: 6, activity: "Evaluation of Technical Parts of Bids", start: "21-Oct-25", end: "25-Mar-26" },

  { no: 7, activity: "Notification of Evaluation of Technical Parts and Public Opening of Financial Parts", start: "26-Mar-26", end: "26-Mar-26" },

  // UPDATED PART
  { no: 8, activity: "Public Opening of Financial Parts (32)", start: "26-May-26", end: "26-May-26" },

  { no: 9, activity: "Correction of Arithmetic Errors (34)", start: "26-May-26", end: "29-May-26" },

  { no: 10, activity: "Evaluation of Financial Parts of Bids (33) → Identify 'most advantageous bid' (abnormally low bid and unbalanced bid)", start: "13-May-26", end: "4-Jun-26" },

  { no: 11, activity: "Evaluation of combined Technical and Financial Parts", start: "25-May-26", end: "4-Jun-26" },

  { no: 12, activity: "Issue Notice Intention to Award (41)", start: "2-Nov-26", end: "2-Nov-26", information: "The combined Technical and Financial Evaluation results are currently under the World Bank's review for the issuance of the No Objection Letter (NOL)" },
  { no: 13, activity: "Standstill Period (40)", start: "3-Nov-26", end: "16-Nov-26", information: "The combined Technical and Financial Evaluation results are currently under the World Bank's review for the issuance of the No Objection Letter (NOL)" },

  { no: 14, activity: "Notification to Award (43)", start: "17-Nov-26", end: "17-Nov-26", information: "The combined Technical and Financial Evaluation results are currently under the World Bank's review for the issuance of the No Objection Letter (NOL)" },
  { no: 15, activity: "Signing of Contract", start: "18-Nov-26", end: "26-Nov-26", information: "The combined Technical and Financial Evaluation results are currently under the World Bank's review for the issuance of the No Objection Letter (NOL)" },
  { no: 16, activity: "Publish Contract Award Notice", start: "27-Nov-26", end: "27-Nov-26", information: "The combined Technical and Financial Evaluation results are currently under the World Bank's review for the issuance of the No Objection Letter (NOL)" }
];

function NonUrban() {
  const url_list = Config.api_domain + "/berkas/active/";
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [openZoomDialog, setOpenZoomDialog] = useState(false);
  const [openAnnouncementPopup, setOpenAnnouncementPopup] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");

        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  const filteredList = list.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedList = filteredList.slice(
    page * entriesPerPage,
    (page + 1) * entriesPerPage
  );

  const handleOpenZoomDialog = () => {
    setOpenZoomDialog(true);
  };

  const handleCloseZoomDialog = () => {
    setOpenZoomDialog(false);
  };

  function getRows() {
    // Simulasi: tanggal publikasi hardcoded (bisa ubah sesuai kebutuhan)
    const hardcodedDate = new Date("2025-10-20T18:00:00");

    // Buat item hardcoded biar bisa ikut disortir
    const hardcodedItem = {
      public_id: "zoom-meeting-hardcoded",
      title: "Announcement Technical Parts Bid Opening",
      time_uploaded: hardcodedDate.toISOString(),
      type: "hardcoded",
    };

    const handleCloseAnnouncementPopup = () => {
      setOpenAnnouncementPopup(false);
    };

    // Gabungin hardcoded + data API
    const combinedList = Array.isArray(list) ? [hardcodedItem, ...list] : [hardcodedItem];

    // Urutkan terbaru ke terlama
    const sortedList = combinedList.sort(
      (a, b) => new Date(b.time_uploaded) - new Date(a.time_uploaded)
    );

    if (sortedList.length === 0) {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={5} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }

    // Render semua baris setelah diurutkan
    return sortedList.map((row, index) => {
      // Jika hardcoded
      if (row.type === "hardcoded") {
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>October 20, 2025</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="zoom-link"
                onClick={handleOpenZoomDialog}
                sx={{ color: "#2196f3" }}
              >
                <LinkIcon />
              </IconButton>
            </StyledTableCell>
            <StyledTableCell />
          </StyledTableRow>
        );
      }

      {/* Announcement Popup */ }
      <Dialog
        open={openAnnouncementPopup}
        onClose={handleCloseAnnouncementPopup}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Announcement – Rescheduling
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>

            <Typography variant="body2">
              Please be advised that the schedule for the Public Opening of Financial Parts
              for the contract titled <strong>
                Procurement of The Provision of Basic Geospatial Data and Base Maps of Non-Urban Areas of Indonesia
                (RFB No: ID-BIG-487988-NC-RFB)
              </strong> has been revised.
            </Typography>

            <Typography variant="body2">
              Due to the additional time required to thoroughly address several inquiries
              regarding the technical evaluation results, the opening originally scheduled
              for <strong>April 13, 2026</strong> has been rescheduled as follows:
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              <Typography variant="body2">
                <strong>Date:</strong> April 16, 2026
              </Typography>

              <Typography variant="body2">
                <strong>Time:</strong> 01.00 P.M (Western Indonesia Time)
              </Typography>

              <Typography variant="body2">
                <strong>Venue / Platform:</strong> To be confirmed
              </Typography>
            </Box>

            <Typography variant="body2">
              The detailed information regarding the venue and/or meeting link will be
              shared in due course. Thank you for your attention.
            </Typography>

          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAnnouncementPopup} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      // Jika dari API
      const dateISO = new Date(row.time_uploaded);
      const formatted_datetime = dateToStringDate(dateISO);

      return (
        <StyledTableRow key={row.public_id}>
          <StyledTableCell>{index + 1}</StyledTableCell>
          <StyledTableCell>{row.title}</StyledTableCell>
          <StyledTableCell>{formatted_datetime}</StyledTableCell>
          <StyledTableCell>
            {/* <IconButton
            aria-label="link"
            component="a"
            href={row.link || "#"}
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </IconButton> */}
          </StyledTableCell>
          <StyledTableCell>
            <IconButton
              aria-label="download"
              component="a"
              href={Config.api_domain + "/berkas/download/" + row.public_id}
              download
            >
              <Download />
            </IconButton>
          </StyledTableCell>
        </StyledTableRow>
      );
    });
  }


  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>

      {/* ✅ Announcement Popup */}
      <Dialog
        open={openAnnouncementPopup}
        onClose={() => setOpenAnnouncementPopup(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Public Opening of Financial Parts
        </DialogTitle>

        <DialogContent dividers>
          <DialogContentText
            component="div"
            sx={{
              whiteSpace: "pre-line",
              fontSize: "0.9rem",
              color: "#333",
              lineHeight: 1.8,
            }}
          >
            <>
              Please be advised that the Public Opening of Financial Parts for the contract titled{" "}
              <strong>
                Procurement of The Provision of Basic Geospatial Data and Base Maps of Non-Urban Areas of Indonesia
              </strong>{" "}
              (RFB No: ID-BIG-487988-NC-RFB) will be conducted as follows:

              <br /><br />

              <strong>Date:</strong> May 25, 2026
              <br />

              <strong>Time:</strong> 01.00 P.M (Western Indonesia Time)
              <br />

              <strong>Offline Venue:</strong> Auditorium Bhumandala (Gedung M) Badan Informasi Geospasial, Jl. Raya Jakarta-Bogor Km. 46 Cibinong, Bogor, Indonesia
              <br />

              <strong>Online Platform:</strong>{" "}
              <a
                href="https://big-go-id.zoom.us/j/97444751061?pwd=byV8Dv8PX8YptMKRTwVY3eYRSVNhO1.1"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#1976d2",
                  textDecoration: "underline",
                  wordBreak: "break-all",
                }}
              >
                Zoom Meeting Link
              </a>

              <br /><br />

              <strong>Meeting ID:</strong> 974 4475 1061
              <br />

              <strong>Passcode:</strong> .i^+&Ma9

              <br /><br />

              <strong>Meeting Chat Link:</strong>{" "}
              <a
                href="https://big-go-id.zoom.us/launch/jc/97444751061"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#1976d2",
                  textDecoration: "underline",
                }}
              >
                Open Chat
              </a>

              <br /><br />

              Thank you for your attention.
            </>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenAnnouncementPopup(false)}
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Container>
        <h2>Non-Urban Project</h2>

        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Link</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Zoom Meeting Dialog */}
        <Dialog
          open={openZoomDialog}
          onClose={handleCloseZoomDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Technical Parts Bid Opening - Zoom Meeting</DialogTitle>
          <DialogContent dividers>
            <Typography variant="body1" paragraph>
              <strong>Procurement Working Group ILASPP DPRWD</strong> is inviting you to a scheduled Zoom meeting.
            </Typography>
            <Typography variant="body2" paragraph>
              <strong>Topic:</strong> Technical Parts Bid Opening for The Provision of Basic Geospatial Data And Base Maps of Urban and Non-Urban Areas Of Indonesia
            </Typography>
            <Typography variant="body2" paragraph>
              <strong>Time:</strong> Oct 21, 2025 01:00 PM Bangkok
            </Typography>
            <Typography variant="body2" paragraph>
              <strong>Join Zoom Meeting:</strong><br />
              <a
                href="https://big-go-id.zoom.us/j/95954655851?pwd=wDEdZgpixORb8u8884SOR3yJEPPuZV.1"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#2196f3", wordBreak: "break-all" }}
              >
                https://big-go-id.zoom.us/j/95954655851?pwd=wDEdZgpixORb8u8884SOR3yJEPPuZV.1
              </a>
            </Typography>
            <Typography variant="body2" paragraph>
              <strong>Meeting ID:</strong> 959 5465 5851<br />
              <strong>Passcode:</strong> M6=ecW%S
            </Typography>
            <Typography variant="body2">
              <strong>Join instructions:</strong><br />
              <a
                href="https://big-go-id.zoom.us/meetings/95954655851/invitations?signature=FE2pEw7EfBVxvneylhS6D-8Jpe-STaeAl1oGt_OWut4"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#2196f3", wordBreak: "break-all" }}
              >
                https://big-go-id.zoom.us/meetings/95954655851/invitations?signature=FE2pEw7EfBVxvneylhS6D-8Jpe-STaeAl1oGt_OWut4
              </a>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseZoomDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <h3>Details Package</h3>
        <TableContainer component={Paper} sx={{ mb: 4 }}>
          <Table sx={{ minWidth: 500 }} aria-label="package table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Package</StyledTableCell>
                <StyledTableCell>Provinces</StyledTableCell>
                <StyledTableCell>Area (km²)</StyledTableCell>
                <StyledTableCell>Duration</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[
                {
                  no: 1,
                  package: "Lot 1 (Kalimantan)",
                  marketApproach: "North Kalimantan, East Kalimantan, South Kalimantan, Central Kalimantan, West Kalimantan",
                  stages: "518,427",
                  deadline: "43 months (equivalent to 1290 calendar days)",
                },
                {
                  no: 2,
                  package: "Lot 2 (Sumatera)",
                  marketApproach: "Aceh, North Sumatera, West Sumatera, Riau, Riau Islands, Bengkulu, Jambi, South Sumatera, Bangka Belitung Islands, Lampung",
                  stages: "452,609",
                  deadline: "40 months (equivalent to 1200 calendar days)",
                },
                {
                  no: 3,
                  package: "Lot 3 (Java, Bali, Nusa Tenggara, Maluku and Papua I)",
                  marketApproach: "Banten, Special Capital Region of Jakarta, West Java, Central Java, Special Region of Yogyakarta, East Java, Bali, West Nusa Tenggara, East Nusa Tenggara, Maluku, North Maluku, West Papua, Southwest Papua",
                  stages: "338,923",
                  deadline: "40 months (equivalent to 1200 calendar days)",
                },
                {
                  no: 4,
                  package: "Lot 4 (Papua II)",
                  marketApproach: "Papua, Highlands Papua, Central Papua, South Papua,",
                  stages: "312,573",
                  deadline: "40 months (equivalent to 1200 calendar days)",
                },
              ].map((row, idx) => (
                <StyledTableRow key={idx}>
                  <StyledTableCell>{row.no}</StyledTableCell>
                  <StyledTableCell>{row.package}</StyledTableCell>
                  <StyledTableCell>{row.marketApproach}</StyledTableCell>
                  <StyledTableCell>{row.stages}</StyledTableCell>
                  <StyledTableCell>{row.deadline}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table sx={{ minWidth: 1000 }} aria-label="timeline table">
            <TableHead>
              <TableRow>
                <StyledTableCell sx={{ width: "5%" }} align="left">No.</StyledTableCell>
                <StyledTableCell sx={{ width: "35%" }}>Activity</StyledTableCell>
                <StyledTableCell sx={{ width: "15%" }} align="left">Start Date</StyledTableCell>
                <StyledTableCell sx={{ width: "15%" }} align="left">End Date</StyledTableCell>
                <StyledTableCell sx={{ width: "30%" }} align="left">Information</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {timelineData.map((row) => (
                <StyledTableRow key={row.no}>
                  <StyledTableCell align="left">{row.no}</StyledTableCell>
                  <StyledTableCell>{row.activity}</StyledTableCell>

                  <StyledTableCell align="left">
                    {(() => {
                      const s = (row.start || "").trim();
                      const m = s.match(
                        /(\d{1,2})-(\w{3})-(\d{2})(?:\s+(\d{1,2})[:.](\d{2}))?(?:.*?(GMT[+-]\d+))?/i
                      );
                      if (!m) return s;

                      const months = {
                        Jan: "January", Feb: "February", Mar: "March", Apr: "April",
                        May: "May", Jun: "June", Jul: "July", Aug: "August",
                        Sep: "September", Oct: "October", Nov: "November", Dec: "December",
                      };

                      const day = m[1].padStart(2, "0");
                      const month = months[m[2]] || m[2];
                      const year = `20${m[3]}`;
                      const time = m[4] ? `${String(m[4]).padStart(2, "0")}:${m[5]}` : "";
                      const tz = m[6] ? ` (${m[6]})` : "";

                      return `${day} ${month} ${year}${time ? `, ${time}` : ""}${tz}`;
                    })()}
                  </StyledTableCell>

                  <StyledTableCell align="left">
                    {(() => {
                      const s = (row.end || "").trim();
                      const m = s.match(
                        /(\d{1,2})-(\w{3})-(\d{2})(?:\s+(\d{1,2})[:.](\d{2}))?(?:.*?(GMT[+-]\d+))?/i
                      );
                      if (!m) return s;

                      const months = {
                        Jan: "January", Feb: "February", Mar: "March", Apr: "April",
                        May: "May", Jun: "June", Jul: "July", Aug: "August",
                        Sep: "September", Oct: "October", Nov: "November", Dec: "December",
                      };

                      const day = m[1].padStart(2, "0");
                      const month = months[m[2]] || m[2];
                      const year = `20${m[3]}`;
                      const time = m[4] ? `${String(m[4]).padStart(2, "0")}:${m[5]}` : "";
                      const tz = m[6] ? ` (${m[6]})` : "";

                      return `${day} ${month} ${year}${time ? `, ${time}` : ""}${tz}`;
                    })()}
                  </StyledTableCell>
                  <StyledTableCell align="left">{row.information || ""}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <p style={{ whiteSpace: "pre-line", textAlign: "justify", marginTop: "1em" }}>
          Reason (English):
          The schedule has been revised because the evaluation process has not yet been completed.
        </p>
        <p style={{ textAlign: "justify" }}>
          Clarifications may be submitted via email to:{" "}
          <a href="mailto:pokja.dprwd@big.go.id" style={{ color: "#1976d2", textDecoration: "underline" }}>
            pokja.dprwd@big.go.id
          </a>
        </p>

      </Container>
    </div>
  );
}

export default NonUrban;